import { render } from "./MessageView.vue?vue&type=template&id=6f3ad2fe"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"

import "./MessageView.vue?vue&type=style&index=0&id=6f3ad2fe&lang=css"
script.render = render

export default script